"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/operations.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Foperations.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileOperation = exports.RemoveAppleId = exports.SetAppleId = exports.RemoveGoogleId = exports.SetGoogleId = exports.RemoveDeviceKeys = exports.RemoveKey = exports.AddKey = exports.SetPassword = exports.RemovePhone = exports.AddPhone = exports.SetEmail = exports.RemoveEmail = exports.AddEmail = exports.SetUsername = void 0;
const protobufPackage = 'com.step.auth.proto';
function createBaseSetUsername() {
    return { username: '' };
}
exports.SetUsername = {
    fromJSON(object) {
        const message = {
            username: isSet(object.username) ? globalThis.String(object.username) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.username !== '') {
            obj.username = message.username;
        }
        return obj;
    },
    create(base) {
        return exports.SetUsername.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUsername();
        message.username = object.username ?? '';
        return message;
    },
};
function createBaseAddEmail() {
    return { email: '' };
}
exports.AddEmail = {
    fromJSON(object) {
        const message = { email: isSet(object.email) ? globalThis.String(object.email) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.email !== '') {
            obj.email = message.email;
        }
        return obj;
    },
    create(base) {
        return exports.AddEmail.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddEmail();
        message.email = object.email ?? '';
        return message;
    },
};
function createBaseRemoveEmail() {
    return { email: '' };
}
exports.RemoveEmail = {
    fromJSON(object) {
        const message = {
            email: isSet(object.email) ? globalThis.String(object.email) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.email !== '') {
            obj.email = message.email;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveEmail.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveEmail();
        message.email = object.email ?? '';
        return message;
    },
};
function createBaseSetEmail() {
    return { email: '' };
}
exports.SetEmail = {
    fromJSON(object) {
        const message = { email: isSet(object.email) ? globalThis.String(object.email) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.email !== '') {
            obj.email = message.email;
        }
        return obj;
    },
    create(base) {
        return exports.SetEmail.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetEmail();
        message.email = object.email ?? '';
        return message;
    },
};
function createBaseAddPhone() {
    return { phone: '' };
}
exports.AddPhone = {
    fromJSON(object) {
        const message = { phone: isSet(object.phone) ? globalThis.String(object.phone) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phone !== '') {
            obj.phone = message.phone;
        }
        return obj;
    },
    create(base) {
        return exports.AddPhone.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddPhone();
        message.phone = object.phone ?? '';
        return message;
    },
};
function createBaseRemovePhone() {
    return { phone: '' };
}
exports.RemovePhone = {
    fromJSON(object) {
        const message = {
            phone: isSet(object.phone) ? globalThis.String(object.phone) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phone !== '') {
            obj.phone = message.phone;
        }
        return obj;
    },
    create(base) {
        return exports.RemovePhone.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemovePhone();
        message.phone = object.phone ?? '';
        return message;
    },
};
function createBaseSetPassword() {
    return { password: '' };
}
exports.SetPassword = {
    fromJSON(object) {
        const message = {
            password: isSet(object.password) ? globalThis.String(object.password) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.password !== '') {
            obj.password = message.password;
        }
        return obj;
    },
    create(base) {
        return exports.SetPassword.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetPassword();
        message.password = object.password ?? '';
        return message;
    },
};
function createBaseAddKey() {
    return { keyId: '', jwkBase64: '', factors: 0, password: '' };
}
exports.AddKey = {
    fromJSON(object) {
        const message = {
            keyId: isSet(object.keyId) ? globalThis.String(object.keyId) : '',
            jwkBase64: isSet(object.jwkBase64) ? globalThis.String(object.jwkBase64) : '',
            factors: isSet(object.factors) ? globalThis.Number(object.factors) : 0,
        };
        if (isSet(object.password)) {
            message.password = globalThis.String(object.password);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.keyId !== '') {
            obj.keyId = message.keyId;
        }
        if (message.jwkBase64 !== '') {
            obj.jwkBase64 = message.jwkBase64;
        }
        if (message.factors !== 0) {
            obj.factors = Math.round(message.factors);
        }
        if (message.password !== undefined && message.password !== '') {
            obj.password = message.password;
        }
        return obj;
    },
    create(base) {
        return exports.AddKey.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddKey();
        message.keyId = object.keyId ?? '';
        message.jwkBase64 = object.jwkBase64 ?? '';
        message.factors = object.factors ?? 0;
        message.password = object.password ?? '';
        return message;
    },
};
function createBaseRemoveKey() {
    return { keyId: '' };
}
exports.RemoveKey = {
    fromJSON(object) {
        const message = {
            keyId: isSet(object.keyId) ? globalThis.String(object.keyId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.keyId !== '') {
            obj.keyId = message.keyId;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveKey.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveKey();
        message.keyId = object.keyId ?? '';
        return message;
    },
};
function createBaseRemoveDeviceKeys() {
    return { deviceId: '' };
}
exports.RemoveDeviceKeys = {
    fromJSON(object) {
        const message = {
            deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.deviceId !== '') {
            obj.deviceId = message.deviceId;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveDeviceKeys.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveDeviceKeys();
        message.deviceId = object.deviceId ?? '';
        return message;
    },
};
function createBaseSetGoogleId() {
    return { idToken: '' };
}
exports.SetGoogleId = {
    fromJSON(object) {
        const message = {
            idToken: isSet(object.idToken) ? globalThis.String(object.idToken) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.idToken !== '') {
            obj.idToken = message.idToken;
        }
        return obj;
    },
    create(base) {
        return exports.SetGoogleId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetGoogleId();
        message.idToken = object.idToken ?? '';
        return message;
    },
};
function createBaseRemoveGoogleId() {
    return { googleId: '' };
}
exports.RemoveGoogleId = {
    fromJSON(object) {
        const message = {
            googleId: isSet(object.googleId) ? globalThis.String(object.googleId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.googleId !== '') {
            obj.googleId = message.googleId;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveGoogleId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveGoogleId();
        message.googleId = object.googleId ?? '';
        return message;
    },
};
function createBaseSetAppleId() {
    return { clientId: '', authCode: '' };
}
exports.SetAppleId = {
    fromJSON(object) {
        const message = {
            clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : '',
            authCode: isSet(object.authCode) ? globalThis.String(object.authCode) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.clientId !== '') {
            obj.clientId = message.clientId;
        }
        if (message.authCode !== '') {
            obj.authCode = message.authCode;
        }
        return obj;
    },
    create(base) {
        return exports.SetAppleId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetAppleId();
        message.clientId = object.clientId ?? '';
        message.authCode = object.authCode ?? '';
        return message;
    },
};
function createBaseRemoveAppleId() {
    return { appleId: '' };
}
exports.RemoveAppleId = {
    fromJSON(object) {
        const message = {
            appleId: isSet(object.appleId) ? globalThis.String(object.appleId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.appleId !== '') {
            obj.appleId = message.appleId;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveAppleId.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveAppleId();
        message.appleId = object.appleId ?? '';
        return message;
    },
};
function createBaseProfileOperation() {
    return {
        setUsername: undefined,
        addEmail: undefined,
        removeEmail: undefined,
        addPhone: undefined,
        removePhone: undefined,
        setPassword: undefined,
        addKey: undefined,
        removeKey: undefined,
        setEmail: undefined,
        removeDeviceKeys: undefined,
        setGoogleId: undefined,
        setAppleId: undefined,
        removeGoogleId: undefined,
        removeAppleId: undefined,
    };
}
exports.ProfileOperation = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.setUsername)) {
            message.setUsername = exports.SetUsername.fromJSON(object.setUsername);
        }
        if (isSet(object.addEmail)) {
            message.addEmail = exports.AddEmail.fromJSON(object.addEmail);
        }
        if (isSet(object.removeEmail)) {
            message.removeEmail = exports.RemoveEmail.fromJSON(object.removeEmail);
        }
        if (isSet(object.addPhone)) {
            message.addPhone = exports.AddPhone.fromJSON(object.addPhone);
        }
        if (isSet(object.removePhone)) {
            message.removePhone = exports.RemovePhone.fromJSON(object.removePhone);
        }
        if (isSet(object.setPassword)) {
            message.setPassword = exports.SetPassword.fromJSON(object.setPassword);
        }
        if (isSet(object.addKey)) {
            message.addKey = exports.AddKey.fromJSON(object.addKey);
        }
        if (isSet(object.removeKey)) {
            message.removeKey = exports.RemoveKey.fromJSON(object.removeKey);
        }
        if (isSet(object.setEmail)) {
            message.setEmail = exports.SetEmail.fromJSON(object.setEmail);
        }
        if (isSet(object.removeDeviceKeys)) {
            message.removeDeviceKeys = exports.RemoveDeviceKeys.fromJSON(object.removeDeviceKeys);
        }
        if (isSet(object.setGoogleId)) {
            message.setGoogleId = exports.SetGoogleId.fromJSON(object.setGoogleId);
        }
        if (isSet(object.setAppleId)) {
            message.setAppleId = exports.SetAppleId.fromJSON(object.setAppleId);
        }
        if (isSet(object.removeGoogleId)) {
            message.removeGoogleId = exports.RemoveGoogleId.fromJSON(object.removeGoogleId);
        }
        if (isSet(object.removeAppleId)) {
            message.removeAppleId = exports.RemoveAppleId.fromJSON(object.removeAppleId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.setUsername !== undefined) {
            obj.setUsername = exports.SetUsername.toJSON(message.setUsername);
        }
        if (message.addEmail !== undefined) {
            obj.addEmail = exports.AddEmail.toJSON(message.addEmail);
        }
        if (message.removeEmail !== undefined) {
            obj.removeEmail = exports.RemoveEmail.toJSON(message.removeEmail);
        }
        if (message.addPhone !== undefined) {
            obj.addPhone = exports.AddPhone.toJSON(message.addPhone);
        }
        if (message.removePhone !== undefined) {
            obj.removePhone = exports.RemovePhone.toJSON(message.removePhone);
        }
        if (message.setPassword !== undefined) {
            obj.setPassword = exports.SetPassword.toJSON(message.setPassword);
        }
        if (message.addKey !== undefined) {
            obj.addKey = exports.AddKey.toJSON(message.addKey);
        }
        if (message.removeKey !== undefined) {
            obj.removeKey = exports.RemoveKey.toJSON(message.removeKey);
        }
        if (message.setEmail !== undefined) {
            obj.setEmail = exports.SetEmail.toJSON(message.setEmail);
        }
        if (message.removeDeviceKeys !== undefined) {
            obj.removeDeviceKeys = exports.RemoveDeviceKeys.toJSON(message.removeDeviceKeys);
        }
        if (message.setGoogleId !== undefined) {
            obj.setGoogleId = exports.SetGoogleId.toJSON(message.setGoogleId);
        }
        if (message.setAppleId !== undefined) {
            obj.setAppleId = exports.SetAppleId.toJSON(message.setAppleId);
        }
        if (message.removeGoogleId !== undefined) {
            obj.removeGoogleId = exports.RemoveGoogleId.toJSON(message.removeGoogleId);
        }
        if (message.removeAppleId !== undefined) {
            obj.removeAppleId = exports.RemoveAppleId.toJSON(message.removeAppleId);
        }
        return obj;
    },
    create(base) {
        return exports.ProfileOperation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProfileOperation();
        message.setUsername = (object.setUsername !== undefined && object.setUsername !== null)
            ? exports.SetUsername.fromPartial(object.setUsername)
            : undefined;
        message.addEmail = (object.addEmail !== undefined && object.addEmail !== null)
            ? exports.AddEmail.fromPartial(object.addEmail)
            : undefined;
        message.removeEmail = (object.removeEmail !== undefined && object.removeEmail !== null)
            ? exports.RemoveEmail.fromPartial(object.removeEmail)
            : undefined;
        message.addPhone = (object.addPhone !== undefined && object.addPhone !== null)
            ? exports.AddPhone.fromPartial(object.addPhone)
            : undefined;
        message.removePhone = (object.removePhone !== undefined && object.removePhone !== null)
            ? exports.RemovePhone.fromPartial(object.removePhone)
            : undefined;
        message.setPassword = (object.setPassword !== undefined && object.setPassword !== null)
            ? exports.SetPassword.fromPartial(object.setPassword)
            : undefined;
        message.addKey = (object.addKey !== undefined && object.addKey !== null)
            ? exports.AddKey.fromPartial(object.addKey)
            : undefined;
        message.removeKey = (object.removeKey !== undefined && object.removeKey !== null)
            ? exports.RemoveKey.fromPartial(object.removeKey)
            : undefined;
        message.setEmail = (object.setEmail !== undefined && object.setEmail !== null)
            ? exports.SetEmail.fromPartial(object.setEmail)
            : undefined;
        message.removeDeviceKeys =
            (object.removeDeviceKeys !== undefined && object.removeDeviceKeys !== null)
                ? exports.RemoveDeviceKeys.fromPartial(object.removeDeviceKeys)
                : undefined;
        message.setGoogleId = (object.setGoogleId !== undefined && object.setGoogleId !== null)
            ? exports.SetGoogleId.fromPartial(object.setGoogleId)
            : undefined;
        message.setAppleId = (object.setAppleId !== undefined && object.setAppleId !== null)
            ? exports.SetAppleId.fromPartial(object.setAppleId)
            : undefined;
        message.removeGoogleId = (object.removeGoogleId !== undefined && object.removeGoogleId !== null)
            ? exports.RemoveGoogleId.fromPartial(object.removeGoogleId)
            : undefined;
        message.removeAppleId = (object.removeAppleId !== undefined && object.removeAppleId !== null)
            ? exports.RemoveAppleId.fromPartial(object.removeAppleId)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=operations.js.map